import { useState } from "react";
import DatePicker from "react-datepicker";
import dayjs from "dayjs";
import { offsetDateByMinutes } from "utils";
import useUniversalStore from "store/universalStore";
import { reminderAPI } from "services";
import { toast } from "sonner";

const AddReminder = ({ existingAccount, onSuccess }) => {
    const { write } = useUniversalStore((state) => state);
    const reminderData = existingAccount?.get("reminder");

    const [scheduleReminder, setScheduleReminder] = useState(reminderData?.date || offsetDateByMinutes(5));
    const edit = !!reminderData;
    const today = dayjs(); // Get the current date and time

    const handleChangeDate = (e) => {
        const newDate = new Date(e);
        // Set newDate time to match the current scheduleReminder time for comparison
        const finalDate = dayjs(newDate).hour(dayjs(scheduleReminder).hour()).minute(dayjs(scheduleReminder).minute()).toDate();

        if (dayjs(finalDate).isBefore(dayjs())) {
            // If it's today and time passed, or if it's a past date
            setScheduleReminder(dayjs().add(5, 'minute').toDate());
            toast.warning("Selected date/time is in the past. Adjusted to current time + 5 mins.");
            return;
        }
        setScheduleReminder(finalDate);
    };

    //method to shedule reminder
    const handleSchedule = async (e) => {
        e.preventDefault();
        try {
            let res;
            if (edit) {
                res = await reminderAPI.updateReminder(existingAccount.id, scheduleReminder);
            } else {
                res = await reminderAPI.addReminder(existingAccount.id, scheduleReminder, true);
            }

            if (res) {
                write({ accounts: res });
                if (onSuccess) onSuccess();
            }
        } catch (error) {
            console.log("error", error);
            toast.error(edit ? "Failed to update Reminder!" : "Failed to schedule Reminder!");
        }
    };

    // Handle time change
    const handleTimeChange = (e) => setScheduleReminder(new Date(e));

    // Add this function to check if selected time is valid
    const isTimeValid = () => {
        const selectedTime = dayjs(scheduleReminder);
        return selectedTime.isAfter(dayjs());
    };

    return (
        <form onSubmit={handleSchedule} className="add-reminder-container animate__animated animate__fadeIn px-md-3">
            <div className="mb-4">
                <div className="mb-4">
                    <label className="display-6 py-2 text-black">
                        When do you want to be Reminded?
                    </label>
                    <div className="d-flex py-3 w-100 justify-content-end">
                        <div className="d-flex border-bottom">
                            <span className="input-group-text bg-transparent border-0 text-app">
                                <i className="bi bi-calendar3"></i>
                            </span>
                            <DatePicker
                                selected={scheduleReminder}
                                onChange={handleChangeDate}
                                dateFormat="dd-MM-yyyy"
                                minDate={new Date()}
                                popperPlacement="bottom-start"
                                className="form-control border-0 shadow-none bg-transparent"
                                placeholderText="Choose a date"
                                onKeyDown={(e) => e.preventDefault()}
                            />
                        </div>

                        <div className="d-flex border-bottom">
                            <span className="input-group-text bg-transparent border-0 text-app">
                                <i className="bi bi-clock"></i>
                            </span>
                            <DatePicker
                                selected={scheduleReminder}
                                onChange={handleTimeChange}
                                showTimeSelect
                                showTimeSelectOnly
                                timeIntervals={15}
                                timeCaption="Time"
                                dateFormat="hh:mm aa"
                                className="form-control border-0 shadow-none bg-transparent"
                                placeholderText="Choose a time"
                                onKeyDown={(e) => e.preventDefault()}
                                filterTime={(time) => {
                                    const selectedDate = dayjs(scheduleReminder);
                                    const isToday = selectedDate.isSame(today, 'day');
                                    if (!isToday) return true;
                                    return dayjs(time).isAfter(dayjs());
                                }}
                            />
                        </div>

                    </div>


                    
                </div>
            </div>

            <div className="d-flex flex-column-reverse flex-sm-row justify-content-center gap-3 mb-4">
                <button
                    type="button"
                    className="btn btn-light py-2 fw-bold text-muted w-100 w-sm-auto"
                    data-bs-dismiss={edit ? "" : "offcanvas"}
                    onClick={() => (edit && onSuccess ? onSuccess() : undefined)}>
                    Cancel
                </button>

                <button
                    type="submit"
                    className="btn btn-app py-2 fw-bold fs-5 shadow-sm d-flex align-items-center justify-content-center gap-2 w-100 w-sm-auto"
                    disabled={!isTimeValid()}>
                    {edit ? "Update" : "Schedule"}
                </button>
            </div>
        </form>
    )
}

export default AddReminder;